
//Représente les paramètres de mise à jour de la visibilité des colonnes d’un utilisateur
export class ASeMettreAJourVisibiliteColonnesUtilisateurParametres 
{
  //Création
  constructor () 
  {
    this.visibilitesColonnes = [];
  }

  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Visibilités des colonnes
  public visibilitesColonnes: ASeVisibiliteColonne[];
}

//Représente la visibilité d’une colonne
export class ASeVisibiliteColonne 
{
  //Identifiant
  public identifiant!: string;

  //Indique si visible
  public visible!: boolean;
}
